import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent implements OnInit {
  modal: NgbModalRef;
  @Input() type = '';
  @Input() confirm = 'ยืนยันการลบ';
  @Input() cancel = 'ยกเลิก';
  @Input() titleText = 'ยืนยันการลบ';
  @Input() textDeleteConfirm = 'ยืนยันอีกครั้งเพื่อทำการลบ';
  @Input() deleteMessage = 'ลบ';
  @Input() disabledButton = false;
  @Output() submitted = new EventEmitter();

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit() {
  }

  open(content) {
    this.modal = this.modalService.open(content);
  }
  submit() {
    this.submitted.emit();
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/core/delete-modal/delete-modal.component.ts